/* ============================================================
   md-filtros.js
   Matchday collection enhancements for Dawn facets:
   - Chip visual state on native checkboxes
   - Custom Sort dropdown (hides native <select>)
   - Product counter above grid
   - Mobile drawer with live "Apply filters (N)" footer
   The pagination is the native one: snippets/pagination.liquid already
   prints the page numbers with ellipsis.
   ============================================================ */
(function () {
  'use strict';

  var SORT_SELECT_IDS = ['SortBy', 'SortBy-vertical'];
  var CARET_SVG =
    '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
    '<path d="M3 5l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var CLOSE_SVG =
    '<svg width="23" height="23" viewBox="0 0 23 23" aria-hidden="true" focusable="false">' +
    '<path d="M5 5l13 13M18 5L5 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';
  var FILTER_SVG =
    '<svg width="17" height="17" viewBox="0 0 17 17" aria-hidden="true" focusable="false">' +
    '<path d="M2 4h13M4 8.5h9M6 13h5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>' +
    '</svg>';
  var SORT_SVG =
    '<svg width="17" height="17" viewBox="0 0 17 17" aria-hidden="true" focusable="false">' +
    '<path d="M5 3v11M3 11l2 3 2-3M12 14V3M10 6l2-3 2 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
    '</svg>';

  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function hasScope() {
    return !!(
      document.querySelector('.facets') ||
      document.getElementById('product-grid')
    );
  }

  function safe(fn) {
    try {
      fn();
    } catch (e) {
      if (window.console && console.error) console.error('[md-filtros]', e);
    }
  }

  /* -------------------------------------------
     1) Chip visual state
     ------------------------------------------- */
  function syncChip(input) {
    var label = input.closest('.facets__label, .facet-checkbox, label');
    if (!label) return;
    if (input.checked) {
      label.classList.add('md-chip--active');
    } else {
      label.classList.remove('md-chip--active');
    }
  }

  function initChips(root) {
    var scope = root || document;
    var inputs = scope.querySelectorAll('.facets input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.mdChipBound === '1') {
        syncChip(input);
        continue;
      }
      input.dataset.mdChipBound = '1';
      syncChip(input);
      input.addEventListener('change', function (e) {
        syncChip(e.currentTarget);
      });
    }
  }

  /* -------------------------------------------
     2) Custom Sort dropdown
     ------------------------------------------- */
  function labelForOption(option) {
    return (option && option.textContent || '').trim();
  }

  function hideNativeSort(select) {
    select.classList.add('md-sort__nativo');
    var field = select.closest('.facet-filters__field');
    if (field) field.classList.add('md-sort-hidden');
    var sortForm = select.closest('.facets-vertical-sort');
    if (sortForm) sortForm.classList.add('md-sort-hidden');
  }

  function buildSortDropdown(select) {
    if (!select || select.dataset.mdSortBound === '1') return;
    select.dataset.mdSortBound = '1';

    var wrapper = document.createElement('div');
    wrapper.className = 'md-sort';
    wrapper.dataset.open = 'false';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'md-sort__gatilho';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var prefix = document.createElement('span');
    prefix.textContent = 'Sort by ';
    var strong = document.createElement('strong');
    strong.className = 'md-sort__label';
    var currentOption = select.options[select.selectedIndex] || select.options[0];
    strong.textContent = labelForOption(currentOption);

    trigger.appendChild(prefix);
    trigger.appendChild(strong);
    trigger.insertAdjacentHTML('beforeend', CARET_SVG);

    var list = document.createElement('ul');
    list.className = 'md-sort__lista';
    list.setAttribute('role', 'listbox');

    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var li = document.createElement('li');
      li.setAttribute('role', 'none');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'md-sort__opcao';
      btn.textContent = labelForOption(opt);
      btn.dataset.value = opt.value;
      btn.setAttribute('role', 'option');
      if (opt.value === select.value) {
        btn.setAttribute('aria-selected', 'true');
      }
      li.appendChild(btn);
      list.appendChild(li);
    }

    wrapper.appendChild(trigger);
    wrapper.appendChild(list);

    var anchor = select.closest('.facet-filters__field') || select.parentElement;
    if (anchor && anchor.parentElement) {
      anchor.parentElement.insertBefore(wrapper, anchor);
    } else {
      select.parentElement.insertBefore(wrapper, select);
    }
    hideNativeSort(select);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = wrapper.dataset.open === 'true';
      wrapper.dataset.open = open ? 'false' : 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    list.addEventListener('click', function (e) {
      var target = e.target.closest('.md-sort__opcao');
      if (!target) return;
      e.preventDefault();
      var value = target.dataset.value;
      select.value = value;
      strong.textContent = target.textContent.trim();
      var opts = list.querySelectorAll('.md-sort__opcao');
      for (var j = 0; j < opts.length; j++) {
        opts[j].removeAttribute('aria-selected');
      }
      target.setAttribute('aria-selected', 'true');
      wrapper.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('click', function (e) {
      if (wrapper.dataset.open !== 'true') return;
      if (wrapper.contains(e.target)) return;
      wrapper.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrapper.dataset.open === 'true') {
        wrapper.dataset.open = 'false';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    wrapper.__mdSelect = select;
    wrapper.__mdLabel = strong;
  }

  function refreshSortLabel() {
    var wrappers = document.querySelectorAll('.md-sort');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      if (!w.__mdSelect || !w.__mdLabel) continue;
      var sel = w.__mdSelect;
      var current = sel.options[sel.selectedIndex] || sel.options[0];
      if (current) w.__mdLabel.textContent = labelForOption(current);
    }
  }

  function initSortDropdown() {
    for (var i = 0; i < SORT_SELECT_IDS.length; i++) {
      var sel = document.getElementById(SORT_SELECT_IDS[i]);
      if (sel) buildSortDropdown(sel);
    }
    refreshSortLabel();
  }

  /* -------------------------------------------
     3) Product counter above grid
     ------------------------------------------- */
  // One page size per list: the search (24 per page) must not leak into a
  // collection (16 per page) and shift its counter.
  function pageSizeKey() {
    return 'md-page-size:' + window.location.pathname;
  }

  function getPageSize() {
    try {
      var stored = parseInt(
        window.sessionStorage.getItem(pageSizeKey()),
        10
      );
      if (stored > 0) return stored;
    } catch (e) {}
    return 0;
  }

  function setPageSize(size) {
    try {
      window.sessionStorage.setItem(pageSizeKey(), String(size));
    } catch (e) {}
  }

  function parseTotal() {
    var el = document.querySelector(
      '#ProductCount, #ProductCountDesktop, [data-product-count]'
    );
    if (!el) return null;
    var text = (el.textContent || '').trim();
    var match = text.match(/(\d[\d.,]*)/);
    if (!match) return null;
    return match[1];
  }

  function updateProductCounter() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var container =
      grid.closest('.md-cards') || grid.closest('.product-grid-container');
    if (!container) return;

    var counter = container.querySelector('.md-contador-produtos');
    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'md-contador-produtos';
      container.insertBefore(counter, container.firstChild);
    }

    var items = grid.querySelectorAll('.grid__item').length;
    if (items === 0) {
      counter.textContent = '';
      return;
    }

    var urlParams;
    try {
      urlParams = new URLSearchParams(window.location.search);
    } catch (e) {
      urlParams = null;
    }
    var page = 1;
    if (urlParams) {
      var p = parseInt(urlParams.get('page') || '1', 10);
      if (!isNaN(p) && p > 0) page = p;
    }

    var pageSize = getPageSize();
    if (page === 1 && items > 0) {
      pageSize = items;
      setPageSize(items);
    }
    if (!pageSize) pageSize = items;

    var first = (page - 1) * pageSize + 1;
    var last = first + items - 1;
    var total = parseTotal() || String(last);
    // Last page (no "next" arrow, which this theme marks as --prev): count from
    // the total, so a visitor landing straight on it does not see wrong numbers.
    var totalNum = parseInt(String(total).replace(/[^0-9]/g, ''), 10);
    var hasNext = !!container.querySelector('.pagination__item--prev');
    if (page > 1 && !hasNext && totalNum >= items) {
      last = totalNum;
      first = totalNum - items + 1;
    }

    counter.textContent =
      "You've seen " +
      first +
      '-' +
      last +
      ' of ' +
      total +
      ' products';
  }

  /* -------------------------------------------
     4) Mobile drawer (Sort/Filter) + Apply footer
     Only where the vertical filters can open as a drawer
     (collections). The search uses horizontal filters and keeps
     its native filter button.
     ------------------------------------------- */
  function drawerWrapper() {
    return document.querySelector('.facets-vertical .facets-wrapper');
  }

  var drawerState = {
    bar: null,
    footer: null,
    overlay: null,
    applyBtn: null,
    header: null,
    bound: false,
  };

  function countActiveFilters() {
    var checked = document.querySelectorAll(
      '.facets input[type="checkbox"]:checked'
    ).length;
    var priceInputs = document.querySelectorAll(
      '.facets price-range input, .facets .facets__price input'
    );
    var priceCount = 0;
    for (var i = 0; i < priceInputs.length; i++) {
      if (priceInputs[i].value && priceInputs[i].value.trim() !== '') {
        priceCount = 1;
        break;
      }
    }
    return checked + priceCount;
  }

  function updateApplyLabel() {
    if (!drawerState.applyBtn) return;
    var count = countActiveFilters();
    var label = count > 0 ? 'Apply filters (' + count + ')' : 'Apply filters';
    // Only touch the DOM when the text really changes: rewriting the same
    // text is a DOM mutation too and used to wake the page observers again
    // in an endless loop that froze the page.
    if (drawerState.applyBtn.textContent !== label) {
      drawerState.applyBtn.textContent = label;
    }
  }

  function openDrawer() {
    var wrapper = drawerWrapper();
    if (!wrapper) return;
    wrapper.classList.add('md-drawer-open');
    if (drawerState.footer) drawerState.footer.classList.add('md-visible');
    if (drawerState.overlay) drawerState.overlay.classList.add('md-visible');
    document.body.style.overflow = 'hidden';
    updateApplyLabel();
  }

  function closeDrawer() {
    var wrapper = drawerWrapper();
    // The theme's own mobile filter (menu-drawer) may be open inside the drawer:
    // close it the same way its Apply button does, so the page can scroll again.
    var nativeSummary = wrapper && wrapper.querySelector('menu-drawer details.mobile-facets__disclosure[open] > summary');
    if (nativeSummary) nativeSummary.click();
    if (wrapper) wrapper.classList.remove('md-drawer-open');
    if (drawerState.footer) drawerState.footer.classList.remove('md-visible');
    if (drawerState.overlay) drawerState.overlay.classList.remove('md-visible');
    document.body.style.overflow = '';
  }

  function ensureMobileBar() {
    var grid = document.getElementById('product-grid');
    var container =
      (grid && grid.closest('.product-grid-container')) ||
      document.querySelector('.product-grid-container');
    if (!container) return null;
    var bar = container.querySelector(':scope > .md-barra-mobile');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'md-barra-mobile';
    bar.innerHTML =
      '<button type="button" class="md-barra-mobile__botao md-barra-mobile__sort">' +
      SORT_SVG +
      '<span>Sort</span>' +
      '</button>' +
      '<button type="button" class="md-barra-mobile__botao md-barra-mobile__filtro">' +
      FILTER_SVG +
      '<span>Filter</span>' +
      '</button>';
    container.insertBefore(bar, container.firstChild);
    return bar;
  }

  function ensureDrawerHeader() {
    var wrapper = drawerWrapper();
    if (!wrapper) return null;
    var header = wrapper.querySelector(':scope > .md-drawer-cabecalho');
    if (header) return header;
    header = document.createElement('div');
    header.className = 'md-drawer-cabecalho';
    header.innerHTML =
      '<h2 class="md-drawer-cabecalho__titulo">Filter</h2>' +
      '<button type="button" class="md-drawer-cabecalho__fechar" aria-label="Close filters">' +
      CLOSE_SVG +
      '</button>';
    wrapper.insertBefore(header, wrapper.firstChild);
    return header;
  }

  function ensureFooter() {
    var footer = document.querySelector('body > .md-drawer-aplicar');
    if (footer) return footer;
    footer = document.createElement('div');
    footer.className = 'md-drawer-aplicar';
    footer.innerHTML =
      '<button type="button" class="md-drawer-aplicar__botao">Apply filters</button>';
    document.body.appendChild(footer);
    return footer;
  }

  function ensureOverlay() {
    var overlay = document.querySelector('body > .md-drawer-overlay');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'md-drawer-overlay';
    document.body.appendChild(overlay);
    return overlay;
  }

  function initMobileDrawer() {
    if (!drawerWrapper()) return;
    var bar = ensureMobileBar();
    var header = ensureDrawerHeader();
    var footer = ensureFooter();
    var overlay = ensureOverlay();

    drawerState.bar = bar;
    drawerState.header = header;
    drawerState.footer = footer;
    drawerState.overlay = overlay;
    drawerState.applyBtn = footer
      ? footer.querySelector('.md-drawer-aplicar__botao')
      : null;

    if (bar && !bar.dataset.mdBound) {
      bar.dataset.mdBound = '1';
      var sortBtn = bar.querySelector('.md-barra-mobile__sort');
      var filterBtn = bar.querySelector('.md-barra-mobile__filtro');
      if (sortBtn) sortBtn.addEventListener('click', openDrawer);
      if (filterBtn) filterBtn.addEventListener('click', openDrawer);
    }

    if (header && !header.dataset.mdBound) {
      header.dataset.mdBound = '1';
      var closeBtn = header.querySelector('.md-drawer-cabecalho__fechar');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    }

    if (footer && !footer.dataset.mdBound) {
      footer.dataset.mdBound = '1';
      var applyBtn = footer.querySelector('.md-drawer-aplicar__botao');
      if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
    }

    if (overlay && !overlay.dataset.mdBound) {
      overlay.dataset.mdBound = '1';
      overlay.addEventListener('click', closeDrawer);
    }

    updateApplyLabel();
  }

  /* -------------------------------------------
     Apply label live: user changes come through the 'change' event and
     the AJAX re-render through the grid observer below. No observer on
     the whole page here (it fired on every change of the page and,
     together with updateApplyLabel, froze home, collections and search).
     ------------------------------------------- */
  function initApplyLabelListener() {
    if (drawerState.bound || !drawerState.applyBtn) return;
    drawerState.bound = true;
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var t = e.target;
      if (
        t.matches &&
        t.matches('.facets input[type="checkbox"], .facets input[type="number"], .facets input[type="text"]')
      ) {
        updateApplyLabel();
      }
    });
  }

  /* -------------------------------------------
     Grid re-render observer (Dawn AJAX replaces #ProductGridContainer)
     The nodes this script inserts (bar, counter, drawer header) do not
     contain the grid, the filters or the pagination, so they never
     trigger this observer again.
     ------------------------------------------- */
  function initGridObserver() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!(node instanceof Element)) continue;
          var touchesGrid =
            node.id === 'product-grid' ||
            node.id === 'ProductGridContainer' ||
            node.querySelector &&
              (node.querySelector('#product-grid') ||
                node.querySelector('.facets') ||
                node.querySelector('.pagination'));
          if (touchesGrid) {
            safe(initChips);
            safe(updateProductCounter);
            // facets.js rewrites .sorting: rebuild the custom Sort (it skips selects already bound)
            safe(initSortDropdown);
            // the AJAX swap removes the mobile Sort/Filter bar: put it back
            safe(initMobileDrawer);
            safe(updateApplyLabel);
            return;
          }
        }
      }
    });
    observer.observe(document.body, { subtree: true, childList: true });
  }

  /* -------------------------------------------
     Boot (one failing step no longer stops the others)
     ------------------------------------------- */
  function boot() {
    if (!hasScope()) return;
    safe(initChips);
    safe(initSortDropdown);
    safe(updateProductCounter);
    safe(initMobileDrawer);
    safe(initApplyLabelListener);
    safe(initGridObserver);
  }

  onReady(boot);
})();
